/* ============ One-time profile migration between origins =====================
   localStorage is origin-bound, so a player who built a collection on
   carnival-dk.web.app arrives at teddychase.com as a stranger. Fix: the new
   origin embeds the old one in a hidden iframe with ?carnival_export=1; the
   old origin posts the profile (name, prizes, device id …) back via
   postMessage, and the new origin imports it ONCE and reloads.
   The export only ever posts to trusted origins — otherwise any site could
   embed us and harvest profiles.
================================================================================ */

const KEYS = ["carnival.name", "carnival.prizes", "carnival.device", "carnival.lang", "carnival.claw"];
const OLD_ORIGIN = "https://carnival-dk.web.app";
const FLAG = "carnival.migrated";

const trustedParents = () => {
  const list = ["https://teddychase.com", "https://www.teddychase.com"];
  // dev/test only: allow a localhost harness to play the "new" origin
  if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
    const extra = localStorage.getItem("carnival.trustParent");
    if (extra) list.push(extra);
  }
  return list;
};

/* Runs on the OLD origin inside the iframe: post the profile to the parent.
   Returns true if this load is an export request (the app then renders nothing). */
export function exportIfAsked() {
  if (!new URLSearchParams(location.search).has("carnival_export")) return false;
  if (window.parent === window) return true;   // opened directly: do nothing
  const data = {};
  for (const k of KEYS) {
    const v = localStorage.getItem(k);
    if (v != null) data[k] = v;
  }
  for (const target of trustedParents()) {
    try { window.parent.postMessage({ carnivalProfile: data }, target); } catch {}
  }
  return true;
}

/* Runs on the NEW origin: if there is no profile here yet, fetch it from the
   old origin exactly once. Reloads the page after a successful import. */
export function importOldProfile() {
  const oldOrigin =
    (location.hostname === "localhost" || location.hostname === "127.0.0.1")
      ? localStorage.getItem("carnival.oldOrigin") || OLD_ORIGIN
      : OLD_ORIGIN;
  if (location.origin === oldOrigin) return;              // we ARE the old origin
  if (localStorage.getItem("carnival.name")) return;      // already a player here
  if (localStorage.getItem(FLAG)) return;                 // tried once already

  const iframe = document.createElement("iframe");
  iframe.style.display = "none";
  iframe.src = oldOrigin + "/?carnival_export=1";
  const done = (imported) => {
    try { localStorage.setItem(FLAG, "1"); } catch {}
    window.removeEventListener("message", onMsg);
    iframe.remove();
    if (imported) location.reload();                      // boot fresh with the profile
  };
  const onMsg = (e) => {
    if (e.origin !== oldOrigin || !e.data || !e.data.carnivalProfile) return;
    const p = e.data.carnivalProfile;
    if (p["carnival.name"]) {
      for (const [k, v] of Object.entries(p)) {
        try { localStorage.setItem(k, v); } catch {}
      }
      done(true);
    } else {
      done(false);                                        // old origin had no profile
    }
  };
  window.addEventListener("message", onMsg);
  document.body.appendChild(iframe);
  setTimeout(() => done(false), 10000);                   // old origin unreachable
}
